export class FormHelper
{
	/**
	 * @private
	 * @param {HTMLFormElement|null} form
	 */
	constructor(form) {
		this.form = form || null;
	}

	/**
	 * @public
	 * @param {string} html
	 * @returns {FormHelper}
	 */
	static createFromHtml(html) {
		const tempNode = document.createElement('div');
		tempNode.innerHTML = html;
		tempNode.style.display = 'none';

		const form = tempNode.querySelector('form');
		return new FormHelper(form);
	}

	/**
	 * @public
	 * @param {HTMLElement} node
	 * @returns {FormHelper}
	 */
	static createFromNode(node) {
		if (node instanceof HTMLFormElement) {
			return new FormHelper(node);
		}
		const form = node.querySelector('form');
		return new FormHelper(form);
	}

	/**
	 * @public
	 * @returns {void}
	 */
	submit() {
		if (!this.canSubmit()) {
			return;
		}

		if (this.isVirtual()) {
			document.body.appendChild(this.form.parentNode);
		}

		HTMLFormElement.prototype.submit.call(this.form);
	}

	/**
	 * @public
	 * @returns {boolean}
	 */
	canSubmit() {
		return this.isValidFormObject() && this.containsAllowedInputTypesOnly();
	}

	/**
	 * @private
	 * @returns {boolean}
	 */
	isValidFormObject() {
		return this.form instanceof HTMLFormElement;
	}

	/**
	 * @private
	 * @returns {boolean}
	 */
	containsAllowedInputTypesOnly() {
		if (!this.form || !this.form.elements) {
			return false;
		}

		// eslint-disable-next-line no-plusplus
		for (let i = 0; i < this.form.elements.length; i++) {
			if (!FormHelper.elementAllowed(this.form.elements[i])) {
				return false;
			}
		}

		return true;
	}

	/**
	 * @private
	 * @param element
	 * @returns {boolean}
	 */
	static elementAllowed(element) {
		const allowedTypes = FormHelper.getAllowedInputTypes();
		if (element instanceof HTMLInputElement) {
			return allowedTypes.indexOf(element.type) !== -1;
		}
		return true;
	}

	/**
	 * @private
	 * @returns {string[]}
	 */
	static getAllowedInputTypes() {
		return ['hidden', 'submit'];
	}

	/**
	 * @public
	 * @returns {boolean}
	 */
	isVirtual() {
		if (this.form) {
			return !document.body.contains(this.form);
		}
		return true;
	}
}